// extracted by mini-css-extract-plugin
export default {"products":"Gy-z","card":"Hy-z","oosMessaging":"Iy-z"};